import { type DatabaseValue } from '@databases/types/database';
import { type DatabaseFilter, DatabaseFilterType } from '@databases/types/database/view';
import { clone } from 'lodash-es';

/**
 * Get default values from a predefined filter. This allows us to set the correct initial values
 * for newly created entries which match the predefined filter.
 */
export function getDefaultValuesForFilter(
  filter: DatabaseFilter | undefined
): Record<string, DatabaseValue> {
  const result: Record<string, DatabaseValue> = {};

  switch (filter?.type) {
    case DatabaseFilterType.AND:
    case DatabaseFilterType.OR:
      for (const f of filter.value) {
        Object.assign(result, getDefaultValuesForFilter(f));
      }
      break;

    case DatabaseFilterType.EQUALS:
      if (!filter.not) {
        result[filter.fieldId] = clone(filter.value);
      }
      break;
  }

  return result;
}
